import React, { useState, useReducer, useEffect, useRef } from "react";
import {
  Button,
  Grid,
  Modal,
  Icon,
  Popup,
  Checkbox,
  Dropdown,
  Label
} from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { columnDefs, defaultColDef } from "./GridParamsLunettes/GridParams";
import { MonturesOptions } from "./DropdownOptions/MonturesOptions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlasses } from "@fortawesome/free-solid-svg-icons";
// import moment from "moment";
import { Editor } from "@tinymce/tinymce-react";

import { useSelector, useDispatch } from "react-redux";
import { selectCounters, Lunettes_Counter_Reducer } from "../../../features/counter/counterSlice";


function Modal_choice_lunnettes_fast(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);
  const editorRef = useRef(null);
  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);
  // const [PREVonline, setPREVOnline] = useState([]);
  const [NewAVOptions, set_O_Val] = useState(MonturesOptions);

  const { ID, syncData, AuthState } = props;

  async function getOneUser() {
    await axios
      .get(`${server}Consultation/Lunettes/${ID}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {

        let remainingArr = response?.data?.filter(data => data.TypeCO === null);

        dispatchRedux(Lunettes_Counter_Reducer(remainingArr?.length));
        dispatch({ type: ACTION.FETCH_SUCCESS, payload: response.data });
      })
      .catch((error) => {
        dispatch({ type: ACTION.FETCH_ERROR, payload: error.response });
      });
  }

  useEffect(() => {
    getOneUser();
  }, [state.open]);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    params.api.setRowData(state.rowData);
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = {
        fk_id_patientLunette: "",
        avOD: "",
        sphOD: "",
        cylOD: "",
        axeOD: "",
        addOD: "",
        created_at: "",
        avOG: "",
        sphOG: "",
        cylOG: "",
        axeOG: "",
        addOG: "",
        observation: "",
        SolaireAntiUV: "",
        Antireflet: "",
        FiltreBlue: "",
        Photocromic: "",
        SolaireAntiUVtxt: "",
        FiltreBluetxt: "",
        Antireflettxt: "",
        Photocromictxt: "",
        selectionChanged: false,
        MontureNewAVOptions: "",
        TypeCO: "",
        fk_id_examen: "",
      };
      dispatch({
        type: ACTION.LOAD_LUNETTES_TABLE,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      let ModclientArray = {
        ...clientArray,
        selectionChanged: true,
      };

      dispatch({
        type: ACTION.LOAD_LUNETTES_TABLE,
        value: ModclientArray,
      });
    }
  };

  const onCellValueChanged = async ({ data }) => {
    axios({
      method: "put",
      responseType: "json",
      url: `${server}Consultation/Lunettes`,
      data: data,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        dispatch({
          type: ACTION.LOAD_LUNETTES_TABLE,
          value: data,
        });
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  async function getDate(params) {
    let res = params.substring(0, 1);

    if (res === "2" && state.id_lunettes && state.fk_id_patientLunette) {
      let data = {
        created_at: params,
        id_lunettes: state.id_lunettes,
        fk_id_patientLunette: state.fk_id_patientLunette,
      };

      axios({
        method: "put",
        responseType: "json",
        url: `${server}Consultation/LunettesDate`,
        data: data,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then((response) => {
          getOneUser();
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  }

  async function UpdateLunettesAttributes() {
    if (state.id_lunettes && state.fk_id_patientLunette) {
      let data = {
        created_at: state.created_atServer,
        id_lunettes: state.id_lunettes,
        fk_id_patientLunette: state.fk_id_patientLunette,
        SolaireAntiUV: state.SolaireAntiUV,
        Antireflet: state.Antireflet,
        FiltreBlue: state.FiltreBlue,
        Photocromic: state.Photocromic,
        MontureNewAVOptions: state.MontureNewAVOptions,
      };

      axios({
        method: "put",
        responseType: "json",
        url: `${server}Consultation/LunettesAttributes`,
        data: data,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then((response) => {
          // dispatchObservation(data.observation)

          // dispatch({
          //     type: ACTION.LOAD_LUNETTES_TABLE,
          //     value: dataToDispatch,
          // });
          getOneUser();
          // scrambleAndRefreshAll()
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  }

  const handleRemoveItem1 = async () => {
    axios({
      method: "DELETE",
      responseType: "json",
      url: `${server}Consultation/Lunettes/${state.id_lunettes}/${state.fk_id_patientLunette}/Lunettes`,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => {
        // dispatch({ type: ACTION.DELETE_SUCCESS })
        getOneUser();
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const PDF_VL_VP = (
    MontureNewAVOptions,
    sphOD,
    cylOD,
    axeOD,
    addOD,

    sphOG,
    cylOG,
    axeOG,
    addOG,

    observation,
    nomPrenomCivilite,
    created_at
  ) => {
    let VP;
    let VL;

    let stringaddOG,
      stringaddOD,
      stringsphOD,
      stringsphOG,
      floataddOG,
      floataddOD,
      floatsphOD,
      floatsphOG,
      sphereAddOG,
      sphereAddOD;

    if (addOG && addOD && sphOD && sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      stringaddOD = addOD.replace(/ /g, "");
      stringsphOD = sphOD.replace(/ /g, "");
      stringsphOG = sphOG.replace(/ /g, "");

      floataddOG = parseFloat(stringaddOG);
      floataddOD = parseFloat(stringaddOD);
      floatsphOD = parseFloat(stringsphOD);
      floatsphOG = parseFloat(stringsphOG);

      sphereAddOG = floataddOG + floatsphOG;
      sphereAddOD = floataddOD + floatsphOD;
    } else if (!addOG && !addOD && !sphOD && !sphOG) {
      sphereAddOD = 0.0;
      sphereAddOG = 0.0;
    } else if (!addOG && !addOD && !sphOD && sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      // stringaddOD = addOD.replace(/ /g, "")
      // stringsphOD = sphOD.replace(/ /g, "")
      stringsphOG = sphOG.replace(/ /g, "");

      // floataddOG = parseFloat(stringaddOG)
      // floataddOD = parseFloat(stringaddOD)
      // floatsphOD = parseFloat(stringsphOD)
      floatsphOG = parseFloat(stringsphOG);

      sphereAddOG = floatsphOG;
      sphereAddOD = 0.0;
    } else if (!addOG && !addOD && sphOD && !sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      // stringaddOD = addOD.replace(/ /g, "")
      stringsphOD = sphOD.replace(/ /g, "");
      // stringsphOG = sphOG.replace(/ /g, "")

      // floataddOG = parseFloat(stringaddOG)
      // floataddOD = parseFloat(stringaddOD)
      floatsphOD = parseFloat(stringsphOD);
      // floatsphOG = parseFloat(stringsphOG)

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = 0.0;
      sphereAddOD = floatsphOD;
    } else if (!addOG && !addOD && sphOD && sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      // stringaddOD = addOD.replace(/ /g, "")
      stringsphOD = sphOD.replace(/ /g, "");
      stringsphOG = sphOG.replace(/ /g, "");

      // floataddOG = parseFloat(stringaddOG)
      // floataddOD = parseFloat(stringaddOD)
      floatsphOD = parseFloat(stringsphOD);
      floatsphOG = parseFloat(stringsphOG);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floatsphOG;
      sphereAddOD = floatsphOD;
    } else if (!addOG && addOD && !sphOD && !sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      stringaddOD = addOD.replace(/ /g, "");
      // stringsphOD = sphOD.replace(/ /g, "")
      // stringsphOG = sphOG.replace(/ /g, "")

      // floataddOG = parseFloat(stringaddOG)
      floataddOD = parseFloat(stringaddOD);
      // floatsphOD = parseFloat(stringsphOD)
      // floatsphOG = parseFloat(stringsphOG)

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = 0.0;
      sphereAddOD = floataddOD;
    } else if (!addOG && addOD && !sphOD && sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      stringaddOD = addOD.replace(/ /g, "");
      // stringsphOD = sphOD.replace(/ /g, "")
      stringsphOG = sphOG.replace(/ /g, "");

      // floataddOG = parseFloat(stringaddOG)
      floataddOD = parseFloat(stringaddOD);
      // floatsphOD = parseFloat(stringsphOD)
      floatsphOG = parseFloat(stringsphOG);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floatsphOG;
      sphereAddOD = floataddOD;
    } else if (!addOG && addOD && sphOD && !sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      stringaddOD = addOD.replace(/ /g, "");
      stringsphOD = sphOD.replace(/ /g, "");
      // stringsphOG = sphOG.replace(/ /g, "")

      // floataddOG = parseFloat(stringaddOG)
      floataddOD = parseFloat(stringaddOD);
      // floatsphOD = parseFloat(stringsphOD)
      floatsphOD = parseFloat(stringsphOD);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = 0.0;
      sphereAddOD = floataddOD + floatsphOD;
    } else if (!addOG && addOD && sphOD && sphOG) {
      // stringaddOG = addOG.replace(/ /g, "")
      stringaddOD = addOD.replace(/ /g, "");
      stringsphOD = sphOD.replace(/ /g, "");
      stringsphOG = sphOG.replace(/ /g, "");

      // floataddOG = parseFloat(stringaddOG)
      floataddOD = parseFloat(stringaddOD);
      floatsphOD = parseFloat(stringsphOD);
      floatsphOG = parseFloat(stringsphOG);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floatsphOG;
      sphereAddOD = floataddOD + floatsphOD;
    } else if (addOG && !addOD && !sphOD && !sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      // stringaddOD = addOD.replace(/ /g, "")
      // stringsphOD = sphOD.replace(/ /g, "")
      // stringsphOG = sphOG.replace(/ /g, "")

      floataddOG = parseFloat(stringaddOG);
      // floataddOD = parseFloat(stringaddOD)
      // floatsphOD = parseFloat(stringsphOD)
      // floatsphOG = parseFloat(stringsphOG)

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG;
      sphereAddOD = 0.0;
    } else if (addOG && !addOD && !sphOD && sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      // stringaddOD = addOD.replace(/ /g, "")
      // stringsphOD = sphOD.replace(/ /g, "")
      stringsphOG = sphOG.replace(/ /g, "");

      floataddOG = parseFloat(stringaddOG);
      // floataddOD = parseFloat(stringaddOD)
      // floatsphOD = parseFloat(stringsphOD)
      floatsphOG = parseFloat(stringsphOG);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG + floatsphOG;
      sphereAddOD = 0.0;
    } else if (addOG && !addOD && sphOD && !sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      // stringaddOD = addOD.replace(/ /g, "")
      stringsphOD = sphOD.replace(/ /g, "");
      // stringsphOG = sphOG.replace(/ /g, "")

      floataddOG = parseFloat(stringaddOG);
      // floataddOD = parseFloat(stringaddOD)
      floatsphOD = parseFloat(stringsphOD);
      // floatsphOG = parseFloat(stringsphOG)

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG;
      sphereAddOD = floatsphOD;
    } else if (addOG && !addOD && sphOD && sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      // stringaddOD = addOD.replace(/ /g, "")
      stringsphOD = sphOD.replace(/ /g, "");
      stringsphOG = sphOG.replace(/ /g, "");

      floataddOG = parseFloat(stringaddOG);
      // floataddOD = parseFloat(stringaddOD)
      floatsphOD = parseFloat(stringsphOD);
      floatsphOG = parseFloat(stringsphOG);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG + floatsphOG;
      sphereAddOD = floatsphOD;
    } else if (addOG && addOD && !sphOD && !sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      stringaddOD = addOD.replace(/ /g, "");
      // stringsphOD = sphOD.replace(/ /g, "")
      // stringsphOG = sphOG.replace(/ /g, "")

      floataddOG = parseFloat(stringaddOG);
      floataddOD = parseFloat(stringaddOD);
      // floatsphOD = parseFloat(stringsphOD)
      // floatsphOG = parseFloat(stringsphOG)

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG;
      sphereAddOD = floataddOD;
    } else if (addOG && addOD && !sphOD && sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      stringaddOD = addOD.replace(/ /g, "");
      // stringsphOD = sphOD.replace(/ /g, "")
      stringsphOG = sphOG.replace(/ /g, "");

      floataddOG = parseFloat(stringaddOG);
      floataddOD = parseFloat(stringaddOD);
      // floatsphOD = parseFloat(stringsphOD)
      floatsphOG = parseFloat(stringsphOG);

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG + floatsphOG;
      sphereAddOD = floataddOD;
    } else if (addOG && addOD && sphOD && !sphOG) {
      stringaddOG = addOG.replace(/ /g, "");
      stringaddOD = addOD.replace(/ /g, "");
      stringsphOD = sphOD.replace(/ /g, "");
      // stringsphOG = sphOG.replace(/ /g, "")

      floataddOG = parseFloat(stringaddOG);
      floataddOD = parseFloat(stringaddOD);
      floatsphOD = parseFloat(stringsphOD);
      // floatsphOG = parseFloat(stringsphOG)

      // sphereAddOG = floataddOG + floatsphOG;
      // sphereAddOD = floataddOD + floatsphOD;

      sphereAddOG = floataddOG;
      sphereAddOD = floataddOD + floatsphOD;
    }

    if (
      MontureNewAVOptions ===
      "Monture pour vision de loin + verres correcteurs" ||
      MontureNewAVOptions === "Monture pour enfant + verres correcteurs"
    ) {
      // VL cases /////////////////////////////////////////////////////////////////////////////
      // 0 0 0 0 ///////////////////////////////////
      if (!sphOD && !cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 0 0 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 0 1 0 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >OG = ${sphOG}</p>`;
      }
      // 0 0 1 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 0 0 ///////////////////////////////////
      else if (!sphOD && cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 1 0 1 ///////////////////////////////////
      else if (!sphOD && cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 1 0 ///////////////////////////////////
      else if (!sphOD && cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG} </p>`;
      }
      // 0 1 1 1 //////////////////////////////////
      else if (!sphOD && cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 0 0 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD}</p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }
      // 1 0 0 1 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD} </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 1 0 //////////////////////////////////
      else if (sphOD && !cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD} </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG} </p>`;
      }
      // 1 0 1 1 /////////////////////////////////
      else if (sphOD && !cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD}</p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 0 0 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }
      // 1 1 0 1 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 1 0 //////////////////////////////
      else if (sphOD && cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG}</p>`;
      }
      //  1 1 1 1 /////////////////////////////
      else if (sphOD && cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
    } else if (
      MontureNewAVOptions === "Monture + verres correcteurs progressifs"
    ) {
      if (addOG && addOD && addOD === addOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">Add </h5>
            <p style="padding-left: 3rem;" >ODG = ${addOD}</p>`;
      } else if (addOG && addOD && addOD !== addOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">Add </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      } else if (!addOG && addOD) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">Add </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      } else if (addOG && !addOD) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">Add </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >OG = ${addOG} </p>`;
      }
      // VL cases /////////////////////////////////////////////////////////////////////////////
      // 0 0 0 0 ///////////////////////////////////
      if (!sphOD && !cylOD && !sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = Plan </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 0 0 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && !sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 0 1 0 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >OG = ${sphOG}</p>`;
      }
      // 0 0 1 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 0 0 ///////////////////////////////////
      else if (!sphOD && cylOD && !sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 1 0 1 ///////////////////////////////////
      else if (!sphOD && cylOD && !sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 1 0 ///////////////////////////////////
      else if (!sphOD && cylOD && sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG} </p>`;
      }
      // 0 1 1 1 //////////////////////////////////
      else if (!sphOD && cylOD && sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 0 0 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = ${sphOD}</p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }
      // 1 0 0 1 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = ${sphOD} </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 1 0 //////////////////////////////////
      else if (sphOD && !cylOD && sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = ${sphOD} </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG} </p>`;
      }
      // 1 0 1 1 /////////////////////////////////
      else if (sphOD && !cylOD && sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >OD = ${sphOD}</p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 0 0 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }
      // 1 1 0 1 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 1 0 //////////////////////////////
      else if (sphOD && cylOD && sphOG && !cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG}</p>`;
      }
      //  1 1 1 1 /////////////////////////////
      else if (sphOD && cylOD && sphOG && cylOG) {
        VL = `<p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
    } else if (
      MontureNewAVOptions === "Monture pour vision de près + verres correcteurs"
    ) {
      if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        !cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }

      // VL cases /////////////////////////////////////////////////////////////////////////////
      // 0 0 0 0 ///////////////////////////////////
      if (!sphOD && !cylOD && !sphOG && !cylOG && !addOD && !addOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 0 0 1 ////////////////////////////////////
      else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 0 1 0 //////////////////////////////////// .toFixed(2)
      else if (!sphOD && !cylOD && sphOG && !cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      } else if (!sphOD && !cylOD && sphOG && !cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      // 0 0 1 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      } else if (!sphOD && !cylOD && sphOG && cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 0 0 ///////////////////////////////////
      else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD === null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG} </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG} </p>`;
      }
      // 0 1 0 1 ///////////////////////////////////
      else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 1 0 ///////////////////////////////////
      else if (!sphOD && cylOD && sphOG && !cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      } else if (!sphOD && cylOD && sphOG && !cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      // 0 1 1 1 //////////////////////////////////
      else if (!sphOD && cylOD && sphOG && cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      } else if (!sphOD && cylOD && sphOG && cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 0 0 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && !cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      } else if (sphOD && !cylOD && !sphOG && !cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      }
      // 1 0 0 1 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (sphOD && !cylOD && !sphOG && cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 1 0 //////////////////////////////////
      else if (sphOD && !cylOD && sphOG && !cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      // 1 0 1 1 /////////////////////////////////
      else if (sphOD && !cylOD && sphOG && cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 0 0 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && !cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      } else if (sphOD && cylOD && !sphOG && !cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      }
      // 1 1 0 1 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (sphOD && cylOD && !sphOG && cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 1 0 //////////////////////////////
      else if (sphOD && cylOD && sphOG && !cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      //  1 1 1 1 /////////////////////////////
      else if (sphOD && cylOD && sphOG && cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
    } else if (
      MontureNewAVOptions ===
      "Monture pour vision de loin + vision de près + verres correcteurs"
    ) {
      // VL cases /////////////////////////////////////////////////////////////////////////////
      // 0 0 0 0 ///////////////////////////////////
      if (!sphOD && !cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 0 0 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 0 1 0 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >OG = ${sphOG}</p>`;
      }
      // 0 0 1 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 0 0 ///////////////////////////////////
      else if (!sphOD && cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 1 0 1 ///////////////////////////////////
      else if (!sphOD && cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 1 0 ///////////////////////////////////
      else if (!sphOD && cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG} </p>`;
      }
      // 0 1 1 1 //////////////////////////////////
      else if (!sphOD && cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 0 0 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD}</p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }
      // 1 0 0 1 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD} </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 1 0 //////////////////////////////////
      else if (sphOD && !cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD} </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG} </p>`;
      }
      // 1 0 1 1 /////////////////////////////////
      else if (sphOD && !cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >OD = ${sphOD}</p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 0 0 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }
      // 1 1 0 1 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 1 0 //////////////////////////////
      else if (sphOD && cylOD && sphOG && !cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${sphOG}</p>`;
      }
      //  1 1 1 1 /////////////////////////////
      else if (sphOD && cylOD && sphOG && cylOG) {
        VL = `<h5 style="padding-left: 2rem;line-height: 1;">VL </h5>
            <p style="padding-left: 3rem;" >
              OD = ${sphOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${sphOG} (${cylOG} à ${axeOG})
            </p>`;
      }

      // VP cases /////////////////////////////////////////////////////////////////////////////
      // 0 0 0 0 ///////////////////////////////////

      if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        !cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      }

      // VL cases /////////////////////////////////////////////////////////////////////////////
      // 0 0 0 0 ///////////////////////////////////
      if (!sphOD && !cylOD && !sphOG && !cylOG && !addOD && !addOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      }
      // 0 0 0 1 ////////////////////////////////////
      else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        !cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 0 1 0 //////////////////////////////////// .toFixed(2)
      else if (!sphOD && !cylOD && sphOG && !cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      } else if (!sphOD && !cylOD && sphOG && !cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      // 0 0 1 1 ////////////////////////////////////
      else if (!sphOD && !cylOD && sphOG && cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = Plan</p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      } else if (!sphOD && !cylOD && sphOG && cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >OD = ${addOD} </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 0 0 ///////////////////////////////////
      else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD === null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG} </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        !cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG} </p>`;
      }
      // 0 1 0 1 ///////////////////////////////////
      else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD != null &&
        addOG === null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (
        !sphOD &&
        cylOD &&
        !sphOG &&
        cylOG &&
        addOD === null &&
        addOG != null
      ) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 0 1 1 0 ///////////////////////////////////
      else if (!sphOD && cylOD && sphOG && !cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      } else if (!sphOD && cylOD && sphOG && !cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      // 0 1 1 1 //////////////////////////////////
      else if (!sphOD && cylOD && sphOG && cylOG && addOD === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD = Plan (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      } else if (!sphOD && cylOD && sphOG && cylOG && addOD != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
               OD = ${addOD} (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 0 0 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && !cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      } else if (sphOD && !cylOD && !sphOG && !cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      }
      // 1 0 0 1 //////////////////////////////////
      else if (sphOD && !cylOD && !sphOG && cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (sphOD && !cylOD && !sphOG && cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 0 1 0 //////////////////////////////////
      else if (sphOD && !cylOD && sphOG && !cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      // 1 0 1 1 /////////////////////////////////
      else if (sphOD && !cylOD && sphOG && cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 0 0 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && !cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = Plan</p>`;
      } else if (sphOD && cylOD && !sphOG && !cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >OG = ${addOG}</p>`;
      }
      // 1 1 0 1 ////////////////////////////////
      else if (sphOD && cylOD && !sphOG && cylOG && addOG === null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = Plan (${cylOG} à ${axeOG})
            </p>`;
      } else if (sphOD && cylOD && !sphOG && cylOG && addOG != null) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG = ${addOG} (${cylOG} à ${axeOG})
            </p>`;
      }
      // 1 1 1 0 //////////////////////////////
      else if (sphOD && cylOD && sphOG && !cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
            </p>`;
      }
      //  1 1 1 1 /////////////////////////////
      else if (sphOD && cylOD && sphOG && cylOG) {
        VP = `<h5 style="padding-left: 2rem;line-height: 1;">VP </h5>
            <p style="padding-left: 3rem;" >
              OD =
              ${sphereAddOD > 0
            ? `+ ${sphereAddOD.toFixed(2)}`
            : sphereAddOD.toFixed(2)
          }
              (${cylOD} à ${axeOD})
            </p>
            <p style="padding-left: 3rem;" >
              OG =
              ${sphereAddOG > 0
            ? `+ ${sphereAddOG.toFixed(2)}`
            : sphereAddOG.toFixed(2)
          }
              (${cylOG} à ${axeOG})
            </p>`;
      }
    }

    return `${nomPrenomCivilite
      ? ` <h4 style="text-align: center;"> Le ${created_at}</h4>
              <h4 style="text-align: center;" >
                ${nomPrenomCivilite}
              </h4>
              <h5>${observation}</h5>`
      : ""
      }
          ${VL ? VL : ""}
          ${VP ? VP : ""}`;
  };

  // const myPDF = (
  //   <BlobProvider
  //     document={PDF_VL_VP(
  //       state.MontureNewAVOptions,
  //       state.sphOD,
  //       state.cylOD,
  //       state.axeOD,
  //       state.addOD,

  //       state.sphOG,
  //       state.cylOG,
  //       state.axeOG,
  //       state.addOG,
  //       state.observation,
  //       state.nomPrenomCivilite,
  //       state.created_at
  //     )}
  //   >
  //     {({ url }) => (
  //       <iframe
  //         src={url}
  //         title="ordonnance"
  //         style={{ width: "100%", height: "70vh" }}
  //       />
  //     )}
  //   </BlobProvider>
  // );

  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={PDF_VL_VP(
          state.MontureNewAVOptions,
          state.sphOD,
          state.cylOD,
          state.axeOD,
          state.addOD,

          state.sphOG,
          state.cylOG,
          state.axeOG,
          state.addOG,
          state.observation,
          state.nomPrenomCivilite,
          state.created_at
        )}
        init={{
          // selector: "textarea",
          branding: false,
          height: "70vh",
          menubar: false,
          noneditable_editable_class: "mceEditable",
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
            "noneditable",
          ],
          toolbar: " print  ",
          content_style:
            "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm;} body{font-size:16px} ",
          setup: function (editor) {
            editor.on("keydown", function (event) {
              if (event.keyCode === 8 || event.keyCode === 46) {
                const currentLine = editor.selection.getNode();

                // Prevent deletion of non editable text
                if (
                  currentLine.hasAttribute("data-mce-bogus") ||
                  currentLine.className.includes("mceNonEditable")
                ) {
                  event.preventDefault();
                  event.stopPropagation();
                  return false;
                }
              }
            });
          },
        }}
      />
    </div>
  );

  const handleAddition = (e, { value }) => {
    set_O_Val((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };

  // function delay(time) {
  //     return new Promise(resolve => setTimeout(resolve, time));
  // }

  const oppenModalFunction = async () => {
    // await functionCorrectioFinnale()
    // await delay(100);

    dispatch({ type: ACTION.OPEN, size: "fullscreen" });
    //
  };
  function globalClosingModalFunc(params) {
    // closeModal_remotely()
    dispatch({ type: ACTION.CLOSE2 });
    dispatch({ type: ACTION.CLOSE });
  }
  async function savePrintAndValider(params) {
    await UpdateLunettesAttributes();
    await getOneUser();

    let Antireflettxt, FiltreBluetxt, SolaireAntiUVtxt, Photocromictxt

    if (
      state.SolaireAntiUV === null ||
      state.SolaireAntiUV === undefined ||
      state.SolaireAntiUV === 0
    ) {
      state.SolaireAntiUV = false;
      SolaireAntiUVtxt = "";
    } else if (state.SolaireAntiUV === false) {
      SolaireAntiUVtxt = "";
    } else {
      SolaireAntiUVtxt = ", solaire anti UV";
    }

    if (
      state.Antireflet === null ||
      state.Antireflet === undefined ||
      state.Antireflet === 0
    ) {
      state.Antireflet = false;
      Antireflettxt = "";
    } else if (state.Antireflet === false) {
      Antireflettxt = "";
    } else {
      Antireflettxt = ", antireflet";
    }

    if (
      state.FiltreBlue === null ||
      state.FiltreBlue === undefined ||
      state.FiltreBlue === 0
    ) {
      state.FiltreBlue = false;
      FiltreBluetxt = "";
    } else if (state.FiltreBlue === false) {
      FiltreBluetxt = "";
    } else {
      FiltreBluetxt = ", filtre anti-lumière bleue";
    }
    if (
      state.Photocromic === null ||
      state.Photocromic === undefined ||
      state.Photocromic === 0
    ) {
      state.Photocromic = false;
      Photocromictxt = "";
    } else if (state.Photocromic === false) {
      Photocromictxt = "";
    } else {
      Photocromictxt = ", photochromiques teintés";
    }

    let observation = `${state.MontureNewAVOptions}${Antireflettxt}${FiltreBluetxt}${SolaireAntiUVtxt}${Photocromictxt}.`;

    // await delay(500);
    dispatch({
      type: ACTION.Fill_FORM_DATA_3_COLUMN_observation,
      payload: observation,
    });

    dispatch({ type: ACTION.OPEN2, size2: "large" });
    // onValueChanged()
    let OGValueToBe;
    let ODValueToBe;

    // pour l'instant ces deux colonnes dans la table Consultation ne servent a rien
    //  let OGprintableText
    // let ODprintableText

    if (state.sphOD && state.cylOD && state.addOD) {
      ODValueToBe = ` ${state.sphOD} (${state.cylOD} à ${state.axeOD}) Add : ${state.addOD}`;
    } else if (state.sphOD && state.cylOD && !state.addOD) {
      ODValueToBe = ` ${state.sphOD} (${state.cylOD} à ${state.axeOD}) `;
    } else if (state.sphOD && !state.cylOD && state.addOD) {
      ODValueToBe = ` ${state.sphOD}  Add : ${state.addOD}`;
    } else if (state.sphOD && !state.cylOD && !state.addOD) {
      ODValueToBe = ` ${state.sphOD}`;
    } else if (!state.sphOD && state.cylOD && !state.addOD) {
      ODValueToBe = ` VL : (${state.cylOD} à ${state.axeOD})`;
    } else if (!state.sphOD && state.cylOD && state.addOD) {
      ODValueToBe = ` VL : (${state.cylOD} à ${state.axeOD}) VP: Add : ${state.addOD}`;
    } else if (!state.sphOD && !state.cylOD && state.addOD) {
      ODValueToBe = ` VP: Add : ${state.addOD}`;
    } else if (!state.sphOD && !state.cylOD && !state.addOD) {
      ODValueToBe = ``;
    }
    // //////////////////////////////////////////OG
    if (state.sphOG && state.cylOG && state.addOG) {
      OGValueToBe = ` ${state.sphOG} (${state.cylOG} à ${state.axeOG}) Add : ${state.addOG}`;
    } else if (state.sphOG && state.cylOG && !state.addOG) {
      OGValueToBe = ` ${state.sphOG} (${state.cylOG} à ${state.axeOG}) `;
    } else if (state.sphOG && !state.cylOG && state.addOG) {
      OGValueToBe = ` ${state.sphOG} Add : ${state.addOG}`;
    } else if (state.sphOG && !state.cylOG && !state.addOG) {
      OGValueToBe = ` ${state.sphOG}`;
    } else if (!state.sphOG && state.cylOG && !state.addOG) {
      OGValueToBe = ` VL : (${state.cylOG} à ${state.axeOG})`;
    } else if (!state.sphOG && state.cylOG && state.addOG) {
      OGValueToBe = ` VL : (${state.cylOG} à ${state.axeOG}) VP: Add : ${state.addOG}`;
    } else if (!state.sphOG && !state.cylOG && state.addOG) {
      OGValueToBe = ` VP: Add : ${state.addOG}`;
    } else if (!state.sphOG && !state.cylOG && !state.addOG) {
      OGValueToBe = ``;
    }

    if (state.avOD) {
      ODValueToBe = `(AV : ${state.avOD}) ${ODValueToBe}`;
    }
    if (state.avOG) {
      OGValueToBe = `(AV : ${state.avOG}) ${OGValueToBe}`;
    }

    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: OGValueToBe,
      od: ODValueToBe,
      fk_id_examen: state.fk_id_examen,
      observation,
      SaveFinalResult: true,

      fk_id_patientLunette: ID,
      avOD: state.avOD,
      sphOD: state.sphOD,
      cylOD: state.cylOD,
      axeOD: state.axeOD,
      addOD: state.addOD,

      avOG: state.avOG,
      sphOG: state.sphOG,
      cylOG: state.cylOG,
      axeOG: state.axeOG,
      addOG: state.addOG,
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation/Lunettes`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  }

  return (
    <>
      {/* <Popup content='Ordonnance Lunettes' trigger={<Button  color="violet" onClick={() => oppenModalFunction()}><FontAwesomeIcon className="FixHeightFontAwsome" icon={faGlasses} size="lg" /><Icon name='history' size='large' className="centerIcon" /></Button>} /> */}
      {/* <Button positive onClick={() => oppenModalFunction()}>
                Valider et prescrire
            </Button> */}
      <Popup
        content="Ordonnance Lunettes"
        trigger={
          <Button

            color="violet"
            onClick={() => oppenModalFunction()}
          >
            <FontAwesomeIcon
              className="FixHeightFontAwsome"
              icon={faGlasses}
              size="lg"
            />
            <Icon name="history" size="large" className="centerIcon" />
            {CountersState?.Lunettes_Counter === 0 ? null :
              <Label color='red' className="floatingnumber">
                {CountersState?.Lunettes_Counter}
              </Label>

            }
          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
        className="lunettesModal"
      >
        <Modal.Header className="center3columnheaders">
          {state.TypeCO ? null : state.selectionChanged ? (
            <Button
              floated="left"
              onClick={() => dispatch({ type: ACTION.OPEN2, size2: "large" })}
              primary
            >
              Visualiser
              <Icon className="leftSpace" name="print" />
            </Button>
          ) : null}
          <Modal
            onClose={() => dispatch({ type: ACTION.CLOSE2 })}
            size={state.size2}
            open={state.open2}
          >
            <Modal.Header>Ordonnnance</Modal.Header>
            <Modal.Content>{Contents}</Modal.Content>
            <Modal.Actions>
              <Button
                icon="reply"
                content="Retour"
                onClick={() => globalClosingModalFunc()}
              />
            </Modal.Actions>
          </Modal>
          Ordonnance CO
          {state.TypeCO ? null : state.id_lunettes ? (
            <input
              // style={styles.datePickerCustom}

              style={{ float: "right" }}
              type="date"
              defaultValue={state.created_atServer}
              onChange={(e) => getDate(e.target.value)}
            />
          ) : (
            <input disabled style={{ float: "right" }} type="date" />
          )}
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={16}>
              <div
                id="myGrid"
                className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData ? state.rowData : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  rowSelection={"single"}
                  onSelectionChanged={onSelectionChanged}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged}
                  enableCellChangeFlash={true}
                ></AgGridReact>
              </div>
              <br />
              <Grid.Row>
                {state.TypeCO ? (
                  <Button
                    negative
                    onClick={handleRemoveItem1}
                    floated="right"
                    icon
                  >
                    <Icon name="delete" />
                  </Button>
                ) : state.id_lunettes ? (
                  <>
                    <Dropdown
                      className="DropDownMonture"
                      value={state.MontureNewAVOptions}
                      onAddItem={handleAddition}
                      search
                      selection
                      // fluid
                      allowAdditions
                      label="Montures"
                      options={NewAVOptions}
                      placeholder="Montures"
                      onChange={(e, data) =>
                        dispatch({
                          type: ACTION.Fill_FORM_Montures_cadre,
                          payload: data.value,
                        })
                      }
                    // onChange={(e, data) => {
                    //     set_O_Val(data);
                    // }}
                    />
                    <Checkbox
                      // defaultValue={}
                      checked={state.Antireflet ? true : false}
                      toggle
                      label="Antireflet"
                      onClick={() =>
                        dispatch({
                          type: ACTION.Fill_FORM_Antireflet,
                          payload: state.Antireflet,
                        })
                      }
                      className="ToggleCkeckboxclass"
                    />
                    <Checkbox
                      // defaultValue={state.SolaireAntiUV}
                      checked={state.SolaireAntiUV ? true : false}
                      toggle
                      label="Solaire anti UV"
                      onClick={() =>
                        dispatch({
                          type: ACTION.Fill_FORM_SolaireAntiUV,
                          payload: state.SolaireAntiUV,
                        })
                      }
                      className="ToggleCkeckboxclass"
                    />
                    <Checkbox
                      // defaultValue={state.FiltreBlue}
                      checked={state.FiltreBlue ? true : false}
                      toggle
                      label="Filtre anti-lumière bleue"
                      onClick={() =>
                        dispatch({
                          type: ACTION.Fill_FORM_FiltreBlue,
                          payload: state.FiltreBlue,
                        })
                      }
                      className="ToggleCkeckboxclass"
                    />
                    <Checkbox
                      // defaultValue={state.FiltreBlue}
                      checked={state.Photocromic ? true : false}
                      toggle
                      label="Photochromiques teintés"
                      onClick={() =>
                        dispatch({
                          type: ACTION.Fill_FORM_Photocromic,
                          payload: state.Photocromic,
                        })
                      }
                      className="ToggleCkeckboxclass"
                    />
                    {/* <Button positive onClick={() => UpdateLunettesAttributes()} icon>
                                                <Icon name='save' />
                                            </Button> */}
                    <Button
                      negative
                      onClick={handleRemoveItem1}
                      floated="right"
                      icon
                    >
                      <Icon name="delete" />
                    </Button>
                  </>
                ) : (
                  <>
                    <Dropdown
                      className="DropDownMonture"
                      disabled
                      // value={state.MontureNewAVOptions}
                      onAddItem={handleAddition}
                      search
                      selection
                      // fluid
                      allowAdditions
                      label="Montures"
                      options={NewAVOptions}
                      placeholder="Montures"
                    // onChange={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA_3_COLUMN_od, payload: data.value })}
                    // onChange={(e, data) => {
                    //     set_O_Val(data);
                    // }}
                    />
                    <Checkbox
                      disabled
                      toggle
                      label="Antireflet"
                      className="ToggleCkeckboxclass"
                    />
                    <Checkbox
                      disabled
                      toggle
                      label="Solaire anti UV"
                      className="ToggleCkeckboxclass"
                    />
                    <Checkbox
                      disabled
                      toggle
                      label="Filtre anti-lumière bleue"
                      className="ToggleCkeckboxclass"
                    />
                    <Checkbox
                      disabled
                      toggle
                      label="Photochromiques teintés"
                      className="ToggleCkeckboxclass"
                    />
                    {/* <Button disabled positive onClick={() => UpdateLunettesAttributes()} icon>
                                                <Icon name='save' />
                                            </Button> */}
                    <Button
                      disabled
                      negative
                      onClick={handleRemoveItem1}
                      floated="right"
                      icon
                    >
                      <Icon name="delete" />
                    </Button>
                  </>
                )}
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
          <Button positive onClick={() => savePrintAndValider()}>
            Valider
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Modal_choice_lunnettes_fast;
